<script>
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';

  import FormDropdown from '../components/FormDropdown.svelte';

  import { formData } from '../stores/formDataStore';

  import { requiredString, validateEmail } from '../utils/validation';

  export let visible;

  const dispatch = createEventDispatcher();

  const contactPrefOpts = ['Yes', 'No'];

  let company = '';
  let error = false;
  let data = {
    firstName: { value: '', error: false, validation: requiredString },
    lastName: { value: '', error: false, validation: requiredString },
    email: { value: '', error: false, validation: validateEmail },
    contactPref: { value: '', error: false, validation: requiredString },
  };

  const inputError = (error) => {
    return error ? ' form-invalid' : '';
  };

  const handleClick = () => {
    error = false;
    Object.keys(data).forEach((key) => {
      const keyData = data[key];
      const valid = keyData.validation(keyData.value);
      if (valid) {
        data = { ...data, [key]: { ...keyData, error: false } };
      } else {
        error = true;
        data = { ...data, [key]: { ...keyData, error: true } };
      }
    });
    if (!error) {
      const newData = {
        firstName: data.firstName.value,
        lastName: data.lastName.value,
        email: data.email.value,
        contactPref: data.contactPref.value,
        company,
      };
      formData.updateFormData(newData);
      dispatch('changePage', { page: 'page2' });
    }
  };
</script>

{#if visible}
  <div
    class="feedback-page-1 feedback-el"
    in:fly={{ x: 600, duration: 600 }}
    out:fly={{ x: -600, duration: 600 }}>
    <h1 class="main-heading mb-default">About You</h1>
    <label for="first-name" class="form-label" />
    <input
      type="text"
      name="first-name"
      bind:value={data.firstName.value}
      placeholder="First Name*"
      class="form-input{inputError(data.firstName.error)}" />
    <label for="last-name" class="form-label" />
    <input
      type="text"
      name="last-name"
      bind:value={data.lastName.value}
      placeholder="Last Name*"
      class={'form-input' + inputError(data.lastName.error)} />
    <label for="email" class="form-label" />
    <input
      type="email"
      name="email"
      bind:value={data.email.value}
      placeholder="Email Address*"
      class={'form-input' + inputError(data.email.error)} />
    <label for="company" class="form-label" />
    <input
      type="text"
      name="company"
      bind:value={company}
      placeholder="Company"
      class="form-input" />
    <FormDropdown
      options={contactPrefOpts}
      placeholder={'Would you like to be contacted regarding your feedback?'}
      error={data.contactPref.error}
      bind:chosenOpt={data.contactPref.value} />
    <button class="btn base bold block centered" on:click={handleClick}>Continue
      Survey</button>
  </div>
{/if}
